import type { CircularProgressProps } from '@mui/material/CircularProgress';
import CircularProgress from '@mui/material/CircularProgress';

function AtpCircularProgress(props: CircularProgressProps) {
  const { size = 24, ...rest } = props;
  return <CircularProgress {...rest} size={size} />;
}

export default AtpCircularProgress;
